import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconButton(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="m18.922 20.922-4.05-4.05-.75 2.25a.44.44 0 0 1-.187.263.53.53 0 0 1-.288.087.5.5 0 0 1-.287-.1.5.5 0 0 1-.188-.275l-2.15-7.15a.73.73 0 0 1 .013-.4.8.8 0 0 1 .187-.325.8.8 0 0 1 .325-.187.73.73 0 0 1 .4-.013l7.2 2.15a.44.44 0 0 1 .263.188.53.53 0 0 1 .087.287q0 .15-.075.288a.4.4 0 0 1-.25.187l-2.25.8 4 4q.3.3.3.7t-.3.7l-.6.6q-.3.3-.7.3a.96.96 0 0 1-.7-.3"
      />
      <path
        fill="currentColor"
        d="M19 10V8H5v8h4a1 1 0 1 1 0 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a1 1 0 1 1-2 0"
      />
    </BaseIcon>
  );
}
